import { getLotteryPrizes } from 'api/client';

const UPDATE_LOTTERY_PRIZE = 'lotteryPrizes/UPDATE_LOTTERY_PRIZE';

const reducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_LOTTERY_PRIZE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default reducer;

export function setLotteryPrize(payload) {
    return {
        type: UPDATE_LOTTERY_PRIZE,
        payload
    };
}

export function lazyGetLotteryPrizeList({ lotteryUUID }) {
    return async (dispatch, getState) => {
        const {
            promo: { uuid: promoUUID },
            lotteryPrizes
        } = getState();

        if (Array.isArray(lotteryPrizes[lotteryUUID])) {
            return lotteryPrizes[lotteryUUID];
        } else {
            const { payload: prizes } = await getLotteryPrizes(promoUUID, lotteryUUID);
            dispatch(setLotteryPrize({ [lotteryUUID]: prizes }));

            return prizes;
        }
    };
}
